import { __assign } from "tslib";
import { v4 as uuid4 } from "uuid";
import { ServiceName } from "./shared/types";
export var createMockAccount = function (_a) {
    var _b = _a === void 0 ? {} : _a, overrides = _b.overrides;
    return __assign({ id: uuid4(), accessLevels: {
            accountAdmin: true,
            projectAdmin: true,
            projectMember: true,
            executive: false,
            noAccess: false,
            acsProjectAdmin: false,
        }, adminGroupId: "36205810", autoAssignSubscriptions: true, createCompanyAccessLevels: ["accountAdmin", "projectAdmin"], createProjectAccessLevels: ["accountAdmin", "projectAdmin"], endDate: "2045-12-31", hasAcsUnifiedProjects: true, hasBim360Projects: true, imageUrl: "sampleUrl", isAccEligible: true, isTrial: false, name: "Golden Gate 2", region: "US", services: [
            {
                displayName: "Project Administration",
                removable: false,
                serviceIcon: "sampleIconUrl",
                serviceName: ServiceName.ProjectAdministration,
            },
            {
                displayName: "Document Management",
                removable: false,
                serviceIcon: "sampleIconUrl",
                serviceName: ServiceName.DocumentManagement,
            },
        ], thumbnailImageUrl: "sampleUrl" }, overrides);
};
